








































































































import Vue from 'vue'
import _ from 'lodash'
import {
  DELETE_EMPLOYEE_REQUIREMENTS, DELETE_SECURITY_ROLE_REQUIREMENTS,
  FETCH_EMPLOYEE_REQUIREMENTS,
  FETCH_REQUIREMENTS_EMPLOYEE_AND_SECURITY,
  FETCH_REQUIREMENTS_METADATA,
  FETCH_SECURITY_REQUIREMENTS,
  SAVE_EMPLOYEE_REQUIREMENTS,
  SAVE_SECURITY_ROLE_REQUIREMENTS
} from '@/store/action-types'
import {
  EmployeeAndSecurityItemEmployee, EmployeeAndSecurityItemSecurity,
  EmployeeAndSecurityResponse,
  EmployeeRequirementsItemResponse,
  EmployeeRequirementsResponse, EmployeeRequirementsValue,
  EmployeeRequirementsValuesResponse, ResponseBase
} from '@/types/service-response'
import { DxColumn, DxDataGrid, DxScrolling } from 'devextreme-vue/data-grid'
import {
  DeleteEmployeeRequirementsPayload, DeleteSecurityRequirementsPayload,
  SaveEmployeeRequirementsPayload,
  SaveSecurityRequirementsPayload
} from '@/types/payload'
import { SnackbarStateEnum } from '@/types/enums'
import ProgressCircular from '@/components/ProgressCircular.vue'

interface RequirementsMetaData {
  key: string
  value: EmployeeRequirementsValue[]
  selected: number | null
  sortByCode: number
  sortByText: number
}

interface ComponentData {
  disableEmployee: boolean
  disableSecurity: boolean
  employeeList: EmployeeAndSecurityItemEmployee[],
  securityList: EmployeeAndSecurityItemSecurity[],
  selectedEmployee: number | null
  selectedSecurity: number | null
  selectedRequirement: EmployeeRequirementsItemResponse | null
  requirementsList: EmployeeRequirementsItemResponse[]
  requirementsMetaDataList: RequirementsMetaData[]

  loading: boolean
  showSnackbar: boolean
  messageSnackbar: string
  snackbarState: number

  sortByPersonalnummer: number
  sortByVorname: number
  sortByName: number
}

export default Vue.extend({
  name: 'ConfigurationPage',

  components: {
    ProgressCircular,
    DxDataGrid,
    DxColumn,
    DxScrolling
  },

  props: {

  },

  data (): ComponentData {
    return {
      disableEmployee: false,
      disableSecurity: false,
      employeeList: [],
      securityList: [],
      selectedEmployee: null,
      selectedSecurity: null,
      selectedRequirement: null,
      requirementsList: [],
      requirementsMetaDataList: [],

      loading: false,
      showSnackbar: false,
      messageSnackbar: '',
      snackbarState: 0,

      sortByPersonalnummer: 0,
      sortByVorname: 0,
      sortByName: 0
    }
  },

  computed: {
    snackbarColor (): boolean {
      return this.snackbarState === SnackbarStateEnum.Success
    },
  },

  methods: {
    customFilter (item: EmployeeRequirementsValue, queryText: string): boolean {
      const textOne = item.Code ? item.Code.toLowerCase() : ''
      const textTwo = item.Text ? item.Text.toLowerCase() : ''
      const searchText = queryText.toLowerCase()

      return textOne.indexOf(searchText) > -1 || textTwo.indexOf(searchText) > -1
    },

    onPersonalnummerSort (): void {
      if(this.sortByPersonalnummer === 0) {
        this.sortByPersonalnummer = 1
        this.sortByVorname = 0
        this.sortByName = 0
        this.employeeList = _.orderBy(this.employeeList, ['PersonalNummer'], ['asc'])
      } else if(this.sortByPersonalnummer === 1) {
        this.sortByPersonalnummer = 2
        this.sortByVorname = 0
        this.sortByName = 0
        this.employeeList = _.orderBy(this.employeeList, ['PersonalNummer'], ['desc'])
      } else if(this.sortByPersonalnummer === 2) {
        this.sortByPersonalnummer = 1
        this.sortByVorname = 0
        this.sortByName = 0
        this.employeeList = _.orderBy(this.employeeList, ['PersonalNummer'], ['asc'])
      }
    },

    onVornameSort (): void {
      if(this.sortByVorname === 0) {
        this.sortByPersonalnummer = 0
        this.sortByVorname = 1
        this.sortByName = 0
        this.employeeList = _.orderBy(this.employeeList, ['Vorname'], ['asc'])
      } else if(this.sortByVorname === 1) {
        this.sortByPersonalnummer = 0
        this.sortByVorname = 2
        this.sortByName = 0
        this.employeeList = _.orderBy(this.employeeList, ['Vorname'], ['desc'])
      } else if(this.sortByVorname === 2) {
        this.sortByPersonalnummer = 0
        this.sortByVorname = 1
        this.sortByName = 0
        this.employeeList = _.orderBy(this.employeeList, ['Vorname'], ['asc'])
      }
    },

    onNameSort (): void {
      if(this.sortByName === 0) {
        this.sortByPersonalnummer = 0
        this.sortByVorname = 0
        this.sortByName = 1
        this.employeeList = _.orderBy(this.employeeList, ['Name'], ['asc'])
      } else if(this.sortByName === 1) {
        this.sortByPersonalnummer = 0
        this.sortByVorname = 0
        this.sortByName = 2
        this.employeeList = _.orderBy(this.employeeList, ['Name'], ['desc'])
      } else if(this.sortByName === 2) {
        this.sortByPersonalnummer = 0
        this.sortByVorname = 0
        this.sortByName = 1
        this.employeeList = _.orderBy(this.employeeList, ['Name'], ['asc'])
      }
    },

    onCodeSort (item: RequirementsMetaData): void {
      const index: number = this.requirementsMetaDataList.indexOf(item)
      if(item.sortByCode === 0) {
        this.requirementsMetaDataList[index].sortByText = 0
        this.requirementsMetaDataList[index].sortByCode = 1
        this.requirementsMetaDataList[index].value = _.orderBy(this.requirementsMetaDataList[index].value, ['Code'], ['asc'])
      } else if(item.sortByCode === 1) {
        this.requirementsMetaDataList[index].sortByText = 0
        this.requirementsMetaDataList[index].sortByCode = 2
        this.requirementsMetaDataList[index].value = _.orderBy(this.requirementsMetaDataList[index].value, ['Code'], ['desc'])
      } else if(item.sortByCode === 2) {
        this.requirementsMetaDataList[index].sortByText = 0
        this.requirementsMetaDataList[index].sortByCode = 1
        this.requirementsMetaDataList[index].value = _.orderBy(this.requirementsMetaDataList[index].value, ['Code'], ['asc'])
      }
    },

    onTextSort (item: RequirementsMetaData): void {
      const index: number = this.requirementsMetaDataList.indexOf(item)
      if(item.sortByText === 0) {
        this.requirementsMetaDataList[index].sortByCode = 0
        this.requirementsMetaDataList[index].sortByText = 1
        this.requirementsMetaDataList[index].value = _.orderBy(this.requirementsMetaDataList[index].value, ['Text'], ['asc'])
      } else if(item.sortByText === 1) {
        this.requirementsMetaDataList[index].sortByCode = 0
        this.requirementsMetaDataList[index].sortByText = 2
        this.requirementsMetaDataList[index].value = _.orderBy(this.requirementsMetaDataList[index].value, ['Text'], ['desc'])
      } else if(item.sortByText === 2) {
        this.requirementsMetaDataList[index].sortByCode = 0
        this.requirementsMetaDataList[index].sortByText = 1
        this.requirementsMetaDataList[index].value = _.orderBy(this.requirementsMetaDataList[index].value, ['Text'], ['asc'])
      }
    },

    onEmployeeChange (): void {
      this.requirementsList = []
      this.requirementsMetaDataList.forEach((item: RequirementsMetaData) => {
        item.selected = null
        item.sortByCode = 0
        item.sortByText = 0
      })
      this.disableSecurity = !!this.selectedEmployee
      if(this.selectedEmployee) {
        this.fetchEmployeeRequirements(this.selectedEmployee)
      }
    },

    onSecurityChange (): void {
      this.requirementsList = []
      this.requirementsMetaDataList.forEach((item: RequirementsMetaData) => {
        item.selected = null
        item.sortByCode = 0
        item.sortByText = 0
      })
      this.disableEmployee = !!this.selectedSecurity
      if(this.selectedSecurity) {
        this.fetchSecurityRequirements(this.selectedSecurity)
      }
    },

    onValueChange (item: RequirementsMetaData): void {
      if(this.disableSecurity && this.selectedEmployee) {
        if(item.selected) {
          const payload: SaveEmployeeRequirementsPayload = {
            i_Mitarbeiter: this.selectedEmployee,
            i_VorgabenName: item.key,
            i_Value: item.selected
          }
          this.onSaveEmployeeRequirements(payload)
        } else {
          const payload: DeleteEmployeeRequirementsPayload = {
            i_Mitarbeiter: this.selectedEmployee,
            i_VorgabenName: item.key
          }
          this.onDeleteEmployeeRequirements(payload)
        }
      } else if (this.disableEmployee && this.selectedSecurity) {
        if(item.selected) {
          const payload: SaveSecurityRequirementsPayload = {
            i_SecurityRolle: this.selectedSecurity,
            i_VorgabenName: item.key,
            i_Value: item.selected
          }
          this.onSaveSecurityRoleRequirements(payload)
        } else {
          const payload: DeleteSecurityRequirementsPayload = {
            i_SecurityRolle: this.selectedSecurity,
            i_VorgabenName: item.key
          }
          this.onDeleteSecurityRoleRequirements(payload)
        }
      }
    },

    async onSaveEmployeeRequirements (payload: SaveEmployeeRequirementsPayload): Promise<void> {
      try {
        const response: ResponseBase = await this.$store.dispatch(SAVE_EMPLOYEE_REQUIREMENTS, payload)
        if(!response.IsError) {
          this.messageSnackbar = response.Result ? response.Result : this.$t('errors.dataHaveBeenSaved').toString()
          this.snackbarState = SnackbarStateEnum.Success
          this.showSnackbar = true
        } else {
          this.messageSnackbar = response.Result ? response.Result : this.$t('errors.dataCouldNotBeSaved').toString()
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      } catch {
        this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved').toString()
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      } finally {
        if(this.selectedEmployee) {
          this.fetchEmployeeRequirements(this.selectedEmployee)
        }
      }
    },

    async onDeleteEmployeeRequirements (payload: DeleteEmployeeRequirementsPayload): Promise<void> {
      try {
        const response: ResponseBase = await this.$store.dispatch(DELETE_EMPLOYEE_REQUIREMENTS, payload)
        if(!response.IsError) {
          this.messageSnackbar = response.Result ? response.Result : this.$t('errors.dataHaveBeenDeleted').toString()
          this.snackbarState = SnackbarStateEnum.Success
          this.showSnackbar = true
        } else {
          this.messageSnackbar = response.Result ? response.Result : this.$t('errors.dataCouldNotBeDeleted').toString()
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      } catch {
        this.messageSnackbar = this.$t('errors.dataCouldNotBeDeleted').toString()
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      } finally {
        if(this.selectedEmployee) {
          this.fetchEmployeeRequirements(this.selectedEmployee)
        }
      }
    },

    async onSaveSecurityRoleRequirements (payload: SaveSecurityRequirementsPayload): Promise<void> {
      try {
        const response: ResponseBase = await this.$store.dispatch(SAVE_SECURITY_ROLE_REQUIREMENTS, payload)
        if(!response.IsError) {
          this.messageSnackbar = response.Result ? response.Result : this.$t('errors.dataHaveBeenSaved').toString()
          this.snackbarState = SnackbarStateEnum.Success
          this.showSnackbar = true
        } else {
          this.messageSnackbar = response.Result ? response.Result : this.$t('errors.dataCouldNotBeSaved').toString()
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      } catch {
        this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved').toString()
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      } finally {
        if(this.selectedSecurity) {
          this.fetchSecurityRequirements(this.selectedSecurity)
        }
      }
    },

    async onDeleteSecurityRoleRequirements (payload: DeleteSecurityRequirementsPayload): Promise<void> {
      try {
        const response: ResponseBase = await this.$store.dispatch(DELETE_SECURITY_ROLE_REQUIREMENTS, payload)
        if(!response.IsError) {
          this.messageSnackbar = response.Result ? response.Result : this.$t('errors.dataHaveBeenDeleted').toString()
          this.snackbarState = SnackbarStateEnum.Success
          this.showSnackbar = true
        } else {
          this.messageSnackbar = response.Result ? response.Result : this.$t('errors.dataCouldNotBeDeleted').toString()
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      } catch {
        this.messageSnackbar = this.$t('errors.dataCouldNotBeDeleted').toString()
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      } finally {
        if(this.selectedSecurity) {
          this.fetchSecurityRequirements(this.selectedSecurity)
        }
      }
    },

    async fetchEmployeeRequirements (item: number): Promise<void> {
      try {
        const response: EmployeeRequirementsResponse = await this.$store.dispatch(FETCH_EMPLOYEE_REQUIREMENTS, item)
        if(!response.IsError && response.Data) {
          this.requirementsList = response.Data
          this.requirementsMetaDataList.forEach((item: RequirementsMetaData) => {
            item.selected = null
            item.sortByCode = 0
            item.sortByText = 0
          })
          this.requirementsList.forEach((item: EmployeeRequirementsItemResponse) => {
            let foundItem: RequirementsMetaData | undefined = this.requirementsMetaDataList.find((i: RequirementsMetaData) => i.key === item.VorgabenName)
            if (foundItem) {
              foundItem.selected = item.Auswahl
            }
          })
        } else {
          this.messageSnackbar = this.$t('errors.dataCouldNotBeRead').toString()
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      } catch {
        this.messageSnackbar = this.$t('errors.dataCouldNotBeRead').toString()
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      }
    },

    async fetchSecurityRequirements (item: number): Promise<void> {
      try {
        const response: EmployeeRequirementsResponse = await this.$store.dispatch(FETCH_SECURITY_REQUIREMENTS, item)
        if(!response.IsError && response.Data) {
          this.requirementsList = response.Data
          this.requirementsMetaDataList.forEach((item: RequirementsMetaData) => {
            item.selected = null
            item.sortByCode = 0
            item.sortByText = 0
          })
          this.requirementsList.forEach((item: EmployeeRequirementsItemResponse) => {
            let foundItem: RequirementsMetaData | undefined = this.requirementsMetaDataList.find((i: RequirementsMetaData) => i.key === item.VorgabenName)
            if (foundItem) {
              foundItem.selected = item.Auswahl
            }
          })
        } else {
          this.messageSnackbar = this.$t('errors.dataCouldNotBeRead').toString()
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      } catch {
        this.messageSnackbar = this.$t('errors.dataCouldNotBeRead').toString()
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      }
    },

    async fetchRequirementsMetaData (): Promise<void> {
      try {
        this.loading = true
        const response: EmployeeRequirementsValuesResponse = await this.$store.dispatch(FETCH_REQUIREMENTS_METADATA)
        this.loading = false
        if(!response.IsError && response.Data) {
          Object.keys(response.Data).forEach((key: string) => {
            this.requirementsMetaDataList.push(
                { key: key, value: response.Data[key], selected: null, sortByCode: 0, sortByText: 0 }
            )
          })
        } else {
          this.messageSnackbar = this.$t('errors.dataCouldNotBeRead').toString()
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      } catch {
        this.loading = false
        this.messageSnackbar = this.$t('errors.dataCouldNotBeRead').toString()
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      }
    },

    async fetchEmployeeAndSecurity (): Promise<void> {
      try {
        const response: EmployeeAndSecurityResponse = await this.$store.dispatch(FETCH_REQUIREMENTS_EMPLOYEE_AND_SECURITY)
        if(!response.IsError && response.Data) {
          this.employeeList = response.Data.ds01.map((item: EmployeeAndSecurityItemEmployee) => {
            item.FullName = `${item.PersonalNummer} ${item.FullName}`
            return item
          })
          this.securityList = _.orderBy(response.Data.ds02, ['Bezeichnung'],['asc'])
        } else {
          this.messageSnackbar = this.$t('errors.dataCouldNotBeRead').toString()
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      } catch {
        this.messageSnackbar = this.$t('errors.dataCouldNotBeRead').toString()
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      }
    }
  },

  mounted () {
    this.fetchEmployeeAndSecurity()
    this.fetchRequirementsMetaData()
  }
})
